import { HttpClient } from "@angular/common/http";
import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from "@angular/router";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewAgendaComponent } from 'app/home/sidebar/newAgenda/new_agenda';
import { MeasureService } from 'app/measure.service';
import { Agenda } from 'app/model/agenda';
import { OptionsComponent } from 'app/opzioni/opzioni';
import { OAuth2Service } from "../angular-rest";
import { Config } from '../config.const';
import { EmailService } from '../email.service';
import { EmailComponent } from '../opzioni/email/email';

@Component({
	selector: 'app-nav',
	templateUrl: './navbar.html',
	styleUrls: ['./navbar.css']
})
export class NavbarComponent implements AfterViewInit {
	@Input()
	agenda: Agenda;

	@Input()
	disableNewEvent: boolean = false;

	@Output()
	onNewEvent = new EventEmitter<MouseEvent>();

	mobileView: boolean;
	emailModalRef: any;

	isSpecialista: boolean = false;

	constructor(
		private modalService: NgbModal,
		public auther: OAuth2Service,
		private router: Router,
		measureService: MeasureService,
		private emailService: EmailService,
		private $http: HttpClient
	) {
		this.mobileView = measureService.isMobile();

		// const userData = JSON.parse(localStorage.getItem('auth-cookie-shortcut'));
		// this.isSpecialista = userData.is_specialista;
		if (!this.emailModalRef) {
			setTimeout(() => {
				this.forceInsertEmail()
			}, 500);
		}
	}

	addAgenda() {
		const modalRef = this.modalService.open(NewAgendaComponent);
	}

	showGeneralSettings() {
		this.modalService.open(OptionsComponent, { size: "lg" });
	}

	print() {
		window.print();
	}

	showSpecializzazione() {
		this.router.navigateByUrl('/app-spe');
	}

	isAgendaAmbulatorio() {
		return document.getElementById("scrollmenu");
	}

	ngAfterViewInit(): void {

	}

	async forceInsertEmail() {
		// verifico se l'utente ha l'email impostata: in caso negativo gli chiedo di inserirla
		const response = await this.emailService.get()
		if (!response.success || !response.data.email) {
			this.emailModalRef = this.modalService.open(EmailComponent, {
				backdrop: 'static',
				keyboard: false
			});
			this.emailModalRef.result.then(() => {
				this.emailModalRef.close()
				this.emailModalRef = null

				// causa ignota, a volte, viene aperta una modale aggiuntiva...
				// nel dubbio le distruggo
				document.getElementsByClassName('modal fade show').item(0).remove()
				document.getElementsByClassName('modal-backdrop fade show').item(0).remove()

			})
		}
	}

	logout() {
		// this.$http.post(`${Config.baseURL}/logout`, {}).subscribe(() => {
			this.auther.logout()
		// })
	}
}



// WEBPACK FOOTER //
// ./src/app/navbar/navbar.ts